export default __webpack_public_path__ + "assets/logo-small.9a169bcb5d885297db4bdfc546461811.svg";